<template>
  <div class="manual-card">
    <div class="header">{{ $lang('操作手册') }}</div>
    <div class="content">
      <div class="manual-box">
        <img src="../images/op_icon.png" alt="" class="manual-icon" />
        <a v-if="$store.state.base.lang === 'CN'" :href="encodeURI('https://cms.jtexpress.com/overseas/jmsmx/vip/墨西哥VIP大客户系统操作手册.pdf')" download="墨西哥VIP大客户系统操作手册.pdf" target="_blank" class="link"
          >墨西哥VIP大客户系统操作手册.pdf
        </a>
        <a v-else href="https://cms.jtexpress.com/overseas/jmsmx/vip/MX_Manual de la Sistema VIP.pdf" download="MX_Manual de la Sistema VIP.pdf" target="_blank" class="link">MX_Manual de la Sistema VIP.pdf</a>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OperationManual',
}
</script>

<style lang="scss" scoped>
.manual-card {
  box-sizing: border-box;
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  height: 100%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .header {
    font-size: 16px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 20px;
  }

  .content {
    margin: 0 auto;
    margin-top: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 144px;
    border-radius: 12px;
    padding: 12px;
    width: calc(100% - 32px);
    background-image: url('../images/op_bg.png');
    background-size: 100% 100%;
    .manual-box {
      text-align: center;
      .manual-icon {
        margin: 0 auto;
        font-size: 48px;
        color: #ff6b6b;
        margin-bottom: 10px;
        display: block;
      }
      .link {
        color: #409eff;
        text-decoration: none;
        font-size: 14px;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
